// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.edit-option[data-v-74e25447]{\n        font-size: 25px;\n}\n.treatment-text[data-v-74e25447] {\n        white-space: pre-wrap;\n        word-wrap: break-word;\n        font-family: inherit;\n        background: none;\n        border: none;\n        padding: 0;\n        margin: 0;\n        font-size: inherit;\n        color: inherit;\n        overflow: visible;\n}\n", ""]);
// Exports
module.exports = exports;
